<div class="acompanhamento-wrapper">
  <!-- CABEÇALHO DA PÁGINA -->
  <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
    <div>
      <h1 class="text-2xl font-extrabold text-gray-800 tracking-tight flex items-center gap-2">
        <span class="w-2.5 h-7 bg-emerald-600 rounded-full inline-block"></span>
        Acompanhamento de Pacientes
      </h1>
      <p class="text-xs sm:text-sm text-gray-500 mt-1 ml-4.5">
        Monitoramento de glicemia em tempo real com triagem de risco
      </p>
    </div>
  </div>

  <!-- BARRA DE FILTROS E CONTROLE -->
  <div class="div-filtros bg-white rounded-2xl p-5 border border-gray-100 shadow-sm mb-6">
    <div class="flex flex-wrap items-center justify-between gap-4">
      <!-- FILTROS PRINCIPAIS -->
      <form [formGroup]="form" class="flex flex-wrap items-center gap-3 flex-1 min-w-[280px]">
        @if (showSelectMunicipio) {
          <mat-form-field class="input-tg min-w-[180px] flex-1 sm:flex-none" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Município</mat-label>
            <mat-select formControlName="municipio" (selectionChange)="onMunicipioChange()">
              @for (municipio of municipiosList; track municipio.id) {
                <mat-option [value]="municipio.id">{{ municipio.nome }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        @if (showSelectUnidade) {
          <mat-form-field class="input-tg min-w-[200px] flex-1 sm:flex-none" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Unidade de Saúde</mat-label>
            <mat-select formControlName="unidadeSaude" (selectionChange)="onChange()">
              @for (unidadeS of unidadeSaudeList; track unidadeS.id) {
                <mat-option [value]="unidadeS.id">{{ unidadeS.nome }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        <mat-form-field class="input-tg min-w-[150px] flex-1 sm:flex-none" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Status</mat-label>
          <mat-select formControlName="status" (selectionChange)="onChange()">
            @for (st of [{id: 1, nome: "Pendentes"}, {id: 2, nome: "Finalizados"}]; track st.id) {
              <mat-option [value]="st.id">{{ st.nome }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <button mat-stroked-button class="btn-clean-filters" (click)="clearFilters()" matTooltip="Restaurar filtros padrão">
          <mat-icon class="text-sm">filter_alt_off</mat-icon>
          Limpar Filtros
        </button>

        <button
          mat-stroked-button
          class="btn-refresh"
          [disabled]="loading"
          matTooltip="Recarregar alertas agora"
          (click)="getListItems()"
        >
          @if (loading) {
            <mat-spinner diameter="18"></mat-spinner>
          } @else {
            <mat-icon>refresh</mat-icon>
          }
        </button>
      </form>

      <!-- CONTROLE DE TEMPORIZADOR -->
      <div class="flex items-center gap-3 bg-gray-50/80 px-4 py-2 rounded-xl border border-gray-200/60">
        <mat-form-field class="input-tg timer-select" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Atualização</mat-label>
          <mat-select [ngModel]="timer" (selectionChange)="onTimerChange($event.value)">
            @for (t of [{title: '10s', value: 10000}, {title: '2 min', value: 120000}, {title: '5 min', value: 300000}]; track t.value) {
              <mat-option [value]="t.value">{{ t.title }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        @if (!timerStoped) {
          <button mat-flat-button class="btn-timer-active" (click)="stopTimer()" matTooltip="Pausar contagem regressiva">
            <span class="pulse-indicator"></span>
            <span class="text-xs font-semibold">Pausar</span>
          </button>
        } @else {
          <button mat-flat-button class="btn-timer-paused" (click)="timerGetItems()" matTooltip="Retomar contagem regressiva">
            <mat-icon class="text-xs">play_arrow</mat-icon>
            <span class="text-xs font-semibold">Retomar</span>
          </button>
        }
      </div>
    </div>
  </div>

  <!-- KANBAN BOARD COM COLUNAS DE RISCO (COM SCROLL NATURAL) -->
  <div class="kanban-board flex gap-6 pb-6 overflow-x-auto items-start">
    <!-- COLUNA CRÍTICA -->
    <div class="kanban-column critico-column flex-1 min-w-[340px] max-w-[420px] bg-red-50/40 rounded-2xl border border-red-100 shadow-sm flex flex-col">
      <div class="kanban-header critico-header flex items-center justify-between p-4 bg-white/90 rounded-t-2xl border-b border-red-100">
        <div class="flex items-center gap-2.5">
          <div class="w-8 h-8 rounded-lg bg-red-100 text-red-600 flex items-center justify-center">
            <mat-icon class="text-lg">error_outline</mat-icon>
          </div>
          <div>
            <h3 class="font-bold text-gray-800 text-base m-0 leading-none">Crítico</h3>
            <span class="text-xs text-red-500 font-medium">Prioridade máxima</span>
          </div>
        </div>
        <span class="badge-count bg-red-100 text-red-700 font-bold px-3 py-1 rounded-full text-xs">
          {{ itemsList.Critico.length }} / {{ totalItems }}
        </span>
      </div>

      <div class="kanban-cards-container flex flex-col gap-4 p-3.5 overflow-y-auto max-h-[calc(100vh-270px)] min-h-[160px]">
        @if (itemsList.Critico.length > 0) {
          @for (item of itemsList.Critico; track item.alerta_id) {
            <pending-alerts-card
              (accessModal)="stopTimer()"
              (closeModal)="timerGetItems()"
              (response)="itemsList.Critico = []; getListItems()"
              [alert]="item"
            />
          }
        } @else {
          <div class="empty-column-state py-8 text-center text-gray-400">
            <mat-icon class="text-3xl text-gray-300">verified</mat-icon>
            <p class="text-xs font-medium mt-1">Nenhum alerta crítico pendente</p>
          </div>
        }
      </div>
    </div>

    <!-- COLUNA MODERADA -->
    <div class="kanban-column moderado-column flex-1 min-w-[340px] max-w-[420px] bg-amber-50/40 rounded-2xl border border-amber-100 shadow-sm flex flex-col">
      <div class="kanban-header moderado-header flex items-center justify-between p-4 bg-white/90 rounded-t-2xl border-b border-amber-100">
        <div class="flex items-center gap-2.5">
          <div class="w-8 h-8 rounded-lg bg-amber-100 text-amber-700 flex items-center justify-center">
            <mat-icon class="text-lg">warning_amber</mat-icon>
          </div>
          <div>
            <h3 class="font-bold text-gray-800 text-base m-0 leading-none">Moderado</h3>
            <span class="text-xs text-amber-600 font-medium">Atenção requerida</span>
          </div>
        </div>
        <span class="badge-count bg-amber-100 text-amber-800 font-bold px-3 py-1 rounded-full text-xs">
          {{ itemsList.Moderado.length }} / {{ totalItems }}
        </span>
      </div>

      <div class="kanban-cards-container flex flex-col gap-4 p-3.5 overflow-y-auto max-h-[calc(100vh-270px)] min-h-[160px]">
        @if (itemsList.Moderado.length > 0) {
          @for (item of itemsList.Moderado; track item.alerta_id) {
            <pending-alerts-card
              (accessModal)="stopTimer()"
              (closeModal)="timerGetItems()"
              (response)="itemsList.Moderado = []; getListItems()"
              [alert]="item"
            />
          }
        } @else {
          <div class="empty-column-state py-8 text-center text-gray-400">
            <mat-icon class="text-3xl text-gray-300">task_alt</mat-icon>
            <p class="text-xs font-medium mt-1">Nenhum alerta moderado pendente</p>
          </div>
        }
      </div>
    </div>

    <!-- COLUNA LEVE -->
    <div class="kanban-column leve-column flex-1 min-w-[340px] max-w-[420px] bg-emerald-50/30 rounded-2xl border border-emerald-100 shadow-sm flex flex-col">
      <div class="kanban-header leve-header flex items-center justify-between p-4 bg-white/90 rounded-t-2xl border-b border-emerald-100">
        <div class="flex items-center gap-2.5">
          <div class="w-8 h-8 rounded-lg bg-emerald-100 text-emerald-700 flex items-center justify-center">
            <mat-icon class="text-lg">info</mat-icon>
          </div>
          <div>
            <h3 class="font-bold text-gray-800 text-base m-0 leading-none">Leve</h3>
            <span class="text-xs text-emerald-600 font-medium">Acompanhamento</span>
          </div>
        </div>
        <span class="badge-count bg-emerald-100 text-emerald-800 font-bold px-3 py-1 rounded-full text-xs">
          {{ itemsList.Leve.length }} / {{ totalItems }}
        </span>
      </div>

      <div class="kanban-cards-container flex flex-col gap-4 p-3.5 overflow-y-auto max-h-[calc(100vh-270px)] min-h-[160px]">
        @if (itemsList.Leve.length > 0) {
          @for (item of itemsList.Leve; track item.alerta_id) {
            <pending-alerts-card
              (accessModal)="stopTimer()"
              (closeModal)="timerGetItems()"
              (response)="itemsList.Leve = []; getListItems()"
              [alert]="item"
            />
          }
        } @else {
          <div class="empty-column-state py-8 text-center text-gray-400">
            <mat-icon class="text-3xl text-gray-300">done_all</mat-icon>
            <p class="text-xs font-medium mt-1">Nenhum alerta leve pendente</p>
          </div>
        }
      </div>
    </div>
  </div>
</div>
